export default __webpack_public_path__ + "static/1.9-Colour-Alone-DO-cabe4ab664479f7f012bac8d6191ea0c.png";